import { IBarcodeStyle, BarcodeKinds } from "../../../../../../../documaker/domain/format/objects";
import { IBarcodeObject } from "../../../../../../domain/editableFormat/objects";
import { IBarcodeObjectBean } from "../../../beans/objects";
import { IntegerTranslator } from "../../values";

export class BarcodeStyleTranslator {
  from(bean: IBarcodeObjectBean): IBarcodeStyle {
    const kind = this.integer.from(bean["@type"]);
    const isQrCode = this.isQrCode(kind);
    return {
      kind,
      separator: bean["@separate"],
      qrCode: {
        cellSize: isQrCode ? this.integer.from(bean["@size"]) : 3,
        version: isQrCode ? this.integer.from(bean["@level"]) : 1,
      },
    };
  }

  to(object: IBarcodeObject) {
    const isQrCode = this.isQrCode(object.barcodeStyle.kind);
    return {
      type: this.integer.to(object.barcodeStyle.kind),
      separate: object.barcodeStyle.separator,
      size: this.integer.to(isQrCode ? object.barcodeStyle.qrCode.cellSize : 3),
      level: this.integer.to(isQrCode ? object.barcodeStyle.qrCode.version : 0),
      mode: this.integer.to(isQrCode ? 3 : 0),
    };
  }

  private isQrCode(kind: BarcodeKinds): boolean {
    return (kind === BarcodeKinds.Qr)
        || (kind === BarcodeKinds.QrSequencial);
  }
 
  private readonly integer = new IntegerTranslator();
}
